import React from 'react'
import { Input } from '@node-space/ui-components'
import type { FieldErrors, UseFormRegister } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import type { ContactFiatInstrumentFormData } from 'pages/Contacts/schemas/contactFiatInstrumentSchema'

type SwiftCodeFieldProps = {
  register: UseFormRegister<ContactFiatInstrumentFormData>
  errors: FieldErrors<ContactFiatInstrumentFormData>
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void
}

export const SwiftCodeField = ({ register, errors, onChange }: SwiftCodeFieldProps) => {
  const { t } = useTranslation()

  return (
    <Input
      {...register('swiftCode')}
      name="swiftCode"
      testId="swiftCode"
      label={t('formFields.swiftCode')}
      placeholder={t('formFields.placeholder.swiftCode')}
      errorText={errors?.swiftCode?.message}
      error={!!errors?.swiftCode?.message}
      onChange={onChange}
    />
  )
}

